import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlNgUiComponentModule, BlPagingModule } from '@blcloud/bl-ng-ui-component';
import { ReportOutputStatusRoutingModule } from './report-output-status-page-routing.module';
import { ReportOutputStatusPageComponent } from './report-output-status-page.component';
import { OutputProgressStatusResource } from '@blcloud/bl-ng-resource';
import { ReportOutputStatusPageService } from './report-output-status-page.service';
import { AutoUpdateModule } from '@blcloud/bl-ng-share-module';

/**
 * 帳票出力状況コンテナーモジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    ReportOutputStatusRoutingModule,
    BlPagingModule,
    AutoUpdateModule
  ],
  exports: [
  ],
  declarations: [
    ReportOutputStatusPageComponent,
  ],
  providers: [
    ReportOutputStatusPageService,
    OutputProgressStatusResource,
    BlPagingModule.forRoot().providers
  ]
})
export class ReportOutputStatusPageModule { }



// WEBPACK FOOTER //
// ./src/app/page/report-output-status-page/report-output-status-page.module.ts